import { useTranslation } from 'react-i18next'
import { useAuth } from '@/features/auth/useAuth'
import { useHouseholdMembers } from './useHouseholdMembers'
import { MemberList } from './MemberList'
import { InviteSection } from './InviteSection'

export function HouseholdView() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const { data: members, isLoading } = useHouseholdMembers()

  if (isLoading) return <p className="text-sm text-muted py-8 text-center">{t('common.loading')}</p>
  if (!members) return null

  const currentMember = members.find((m) => m.userId === user?.id)
  const isPlanner = currentMember?.role === 'Planner'

  return (
    <div className="space-y-8">
      <MemberList members={members} currentUserId={user?.id ?? ''} />
      <InviteSection isPlanner={isPlanner} />
    </div>
  )
}
